export default __webpack_public_path__ + "static/media/wftm.16c07d9f.svg";